/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import BASESvgIcon from "../../../../@BASE/core/BASESvgIcon";
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Checkbox from '@mui/material/Checkbox';
import { forwardRef } from "react";

const LessonSelect = forwardRef((props, ref) => {
  const { value, onChange, className, lessons } = props;

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    onChange(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  return (
    <FormControl fullWidth className={className}>
      <InputLabel id="select-label">Lessons</InputLabel>
      <Select
        labelId="select-label"
        id="label-select"
        multiple
        value={value}
        label="Label"
        onChange={handleChange}
        ref={ref}
        input={<OutlinedInput label="Lessons" />}
        renderValue={(selected) => {
          if (!selected.length) {
            return <span className="text-gray-500">Select lessons</span>;
          }

          return (
            <div className="flex flex-wrap gap-8">
              {selected.map((id) => {
                const lesson = lessons.find((l) => l.id === id);
                return (
                  <div
                    key={id}
                    className="flex items-center gap-2"
                  >
                    <BASESvgIcon size={18}>heroicons-outline:check</BASESvgIcon>
                    <span>{lesson?.label}</span>
                  </div>
                );
              })}
            </div>
          );
        }}
        classes={{ select: "flex items-center space-x-12" }}
        size="small"
        required
      >
        <MenuItem value="" disabled className="space-x-12">
          <span>Select lessons</span>
        </MenuItem>
        {lessons.map((lesson) => (
          <MenuItem value={lesson.id} key={lesson.id} className="space-x-12">
            <Checkbox checked={value?.includes(lesson.id)} />
            <span>{lesson.label}</span>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
});

export default LessonSelect;
